import { BmHttp } from "../utils/Global";

// ORDENES-IMPRIMIR-01: con responseType "blob" el cuerpo del error también
// llega como Blob; se lee para no perder el motivo real (403 por permiso,
// "No existe firma de doctor.", etc.) detrás de un "No se pudo" genérico.
const motivoErrorPdf = async (error) => {
  const status = error?.response?.status;
  let message;
  try {
    const data = error?.response?.data;
    message = data instanceof Blob ? JSON.parse(await data.text())?.message : data?.message;
  } catch (e) {
    message = undefined;
  }
  return { success: false, status, message };
};

// Texto para el aviso de la pantalla a partir de lo que devolvió el generador.
export const textoErrorPdf = (r) => {
  if (r?.status === 403) return "Tu rol no tiene permiso para imprimir recetas ni órdenes.";
  if (/firma/i.test(r?.message || "")) {
    return "El doctor de esta cita no tiene cargado su sello/firma. Súbelo en Configuración → Doctores → Sello / Firma.";
  }
  return r?.message || "Intenta de nuevo.";
};

export const createPDFlaboratorio = async (id) => {
  try {
    const response = await BmHttp().get(`genera-pdf-laboratorio/${id}`, {
      responseType: "blob",
    });

    if (response.status === 200) {
      const link = document.createElement("a");
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      link.download = "HCU_10.pdf";
      //link.download =`HCU_010-${nombrePaciente}.pdf`;

      link.click();
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    return motivoErrorPdf(error);
  }
};

export const createPDFimagen = async (id) => {
  try {
    const response = await BmHttp().get(`genera-pdf-imagenes/${id}`, {
      responseType: "blob",
    });

    if (response.status === 200) {
      const link = document.createElement("a");
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      link.download = "HCU_12.pdf";
      //link.download =`HCU_012-${nombrePaciente}.pdf`;
      link.click();
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    return motivoErrorPdf(error);
  }
};
export const createPDFimagenH002 = async (id) => {
  try {
    //alert(id);
    const response = await BmHttp().get(`genera-pdf-h002/${id}`, {
      responseType: "blob",
    });

    if (response.status === 200) {
      const link = document.createElement("a");
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      link.download = "HCU_002.pdf";
      //link.download =`HCU_012-${nombrePaciente}.pdf`;
      link.click();
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    return motivoErrorPdf(error);
  }
};
export const createPDFInterconsulta = async (id) => {
  try {
    const response = await BmHttp().get(`genera-pdf-interconsulta/${id}`, {
      responseType: "blob",
    });

    if (response.status === 200) {
      const link = document.createElement("a");
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      link.download = "HCU_INTERCONSULTA.pdf";
      //link.download =`HCU_012-${nombrePaciente}.pdf`;
      link.click();
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    return motivoErrorPdf(error);
  }
};
export const createPDFimagenExterna = async (id) => {
  try {
    const response = await BmHttp().get(`genera-pdf-imagenesExternas/${id}`, {
      responseType: "blob",
    });

    if (response.status === 200) {
      const link = document.createElement("a");
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      link.download = "ORDEN_EXTERNA.pdf";
      //link.download =`HCU_012-${nombrePaciente}.pdf`;
      link.click();
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    return motivoErrorPdf(error);
  }
};
export const createPDFreceta = async (id, nombrePaciente) => {
  try {
    const response = await BmHttp().get(`genera-pdf-receta/${id}`, {
      responseType: "blob",
    });

    if (response.status === 200) {
      const link = document.createElement("a");
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      //link.download = 'receta.pdf';
      link.download = `RECETA-${nombrePaciente}.pdf`;
      link.click();
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    return motivoErrorPdf(error);
  }
};

export const createPDFCotizacionlaboratorio = async (id) => {
  try {
    const response = await BmHttp().get(
      `genera-pdf-laboratorio-cotizacion/${id}`,
      { responseType: "blob" }
    );

    if (response.status === 200) {
      const link = document.createElement("a");
      const blob = response.data;
      const objectURL = URL.createObjectURL(blob);
      link.href = objectURL;
      link.download = "HCU_10.pdf";
      //link.download =`HCU_010-${nombrePaciente}.pdf`;

      link.click();
      return { success: true };
    } else {
      return { success: false };
    }
  } catch (error) {
    console.error("Error al generar el PDF:", error);
    return motivoErrorPdf(error);
  }
};
